import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

export interface WasteProducer {
    _id: string;
    designation: string;
    siret: string;
    contactLastName?: string;
    contactFirstName?: string;
    contactEmail?: string;
    contactPhone?: string;
    crudStatus: number;
    createdAt?: string;
    updatedAt?: string;
}

interface WasteProducersResponse {
    message: string;
    data: WasteProducer[];
}

export interface GetWasteProducersQueries {
    active?: boolean;
}

export const getAllWasteProducers = async (queries?: GetWasteProducersQueries): Promise<WasteProducersResponse> => {
    try {
        const response: AxiosResponse<WasteProducersResponse> = await apiClient.get('/waste-producers', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface WasteProducerResponse {
    message: string;
    data: WasteProducer;
}

export const getWasteProducerById = async (id: string): Promise<WasteProducerResponse> => {
    try {
        const response: AxiosResponse<WasteProducerResponse> = await apiClient.get('/waste-producers/' + id);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface CreateWasteProducerBody {
    designation: string;
    siret: string;
    contactLastName?: string;
    contactFirstName?: string;
    contactEmail?: string;
    contactPhone?: string;
    crudStatus?: number;
}

export const createWasteProducer = async (data: CreateWasteProducerBody): Promise<WasteProducerResponse> => {
    try {
        const response: AxiosResponse<WasteProducerResponse> = await apiClient.post('/waste-producers', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface UpdateWasteProducerBody {
    designation?: string;
    siret?: string;
    contactLastName?: string;
    contactFirstName?: string;
    contactEmail?: string;
    contactPhone?: string;
    crudStatus?: number;
}

export const updateWasteProducer = async (id: string, data: UpdateWasteProducerBody): Promise<WasteProducerResponse> => {
    try {
        const response: AxiosResponse<WasteProducerResponse> = await apiClient.patch('/waste-producers/' + id, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export const deleteWasteProducer = async (id: string): Promise<WasteProducerResponse> => {
    try {
        const response: AxiosResponse<WasteProducerResponse> = await apiClient.delete('/waste-producers/' + id);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
